import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CandidacyStatusChange, HttpResponse, UpdateCandidacyStatusChangeRequest } from "@/types";

export function useUpdateCandidacyStatusChange() {
  return useMutation({
    mutationFn: async ({
      candidacyId,
      candidacyStatusChangeId,
      companyId,
      jobId,
      updateCandidacyStatusChangeRequest,
    }: {
      candidacyId: string;
      candidacyStatusChangeId: number;
      companyId: string;
      jobId: string;
      updateCandidacyStatusChangeRequest: UpdateCandidacyStatusChangeRequest;
    }) => {
      const path = `companies/${companyId}/jobs/${jobId}/candidacies/${candidacyId}/candidacy_status_changes/${candidacyStatusChangeId.toString()}`;
      const res = await guacHttpClient.patch<CandidacyStatusChange, HttpResponse<CandidacyStatusChange>, UpdateCandidacyStatusChangeRequest>(path, updateCandidacyStatusChangeRequest);
      return res.data;
    },
  });
}
